import { useEffect, useState } from "react";
import {
  isApiUnreachable,
  subscribeApiReachability,
} from "../../utils/api/apiReachability";
import styles from "../../styles/components/common/ApiUnreachableBanner.module.css";

const reloadPage = () => {
  window.location.reload();
};

const ApiUnreachableBanner = ({ onRetry = reloadPage }) => {
  const [unreachable, setUnreachable] = useState(isApiUnreachable);

  useEffect(() => subscribeApiReachability(setUnreachable), []);

  if (!unreachable) return null;

  return (
    <div className={styles.banner} role="alert">
      <p className={styles.message}>
        We can&apos;t reach Simpary right now. Check your connection and try again.
      </p>
      <button type="button" className={styles.retry} onClick={onRetry}>
        Retry
      </button>
    </div>
  );
};

export default ApiUnreachableBanner;
